import React from 'react';
import { TextBox, TextArea } from './inputs.js';

const FormTextBox = ({ field, form, ...props }) => <TextBox {...field} {...form} {...props} />;

const FormTextArea = ({ field, form, ...props }) => <TextArea {...field} {...form} {...props} />;

export { FormTextBox, FormTextArea };
